import { copilotContext as e, copilotTools as t } from "./global-state.js";
import { prepareContextForTransport as n, prepareInstructionsForTransport as r, prepareToolsForTransport as i } from "./session.js";
//#region src/generate.ts
function a(a, o, s = {}) {
	s = {
		instructions: s.instructions ?? [],
		context: s.context ?? [],
		includeGlobalContext: !0,
		includeGlobalTools: !1,
		...s
	};
	let c = window.__hydra_copilot__?.generate;
	if (c == null) throw Error("Copilot generate not configured. Please set the Copilot configuration first.");
	return c({
		message: a,
		schema: o,
		instructions: [...r(s.instructions)],
		tools: s.includeGlobalTools ? i(t.get()) : [],
		context: [...s.includeGlobalContext ? n(e.get()) : [], ...n(s.context)],
		...s.includeUserContext === !0 && { include_user_context: !0 },
		...s.agent != null && { agent: s.agent },
		...s.feature != null && { feature: s.feature }
	});
}
//#endregion
export { a as generate };
